import React, { useState } from 'react';
import {
  Button, TextField, Link, Grid, Typography, Select, FormHelperText, FormControl,
  MenuItem, InputAdornment, IconButton, Divider,
  FormControlLabel, FormGroup, Checkbox,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import FacebookLogin from '@greatsumini/react-facebook-login';
import PropTypes from 'prop-types';

import { isEmpty } from '../common/helpers';

const SignUpForm = ({ guardar, google, facebook, error, disable }) => {
  // Cargar las claves desde el .env
  const FACEBOOK_APP = process.env.REACT_APP_FACEBOOK_APP_ID;
  const infoInput  = {
    username: '',
    email: '',
    tel: '',
    pass: '',
    confirmarPass: '',
    prefijo: '52',
    politicas: '',
    terminos: ''
  }
  const [data, setData] = useState(infoInput);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfimPassword, setShowConfimPassword] = useState(false);
  const [aceptarTerms, setAceptarTerms] = useState(false);
  const [aceptarPolit, setAceptarPolit] = useState(false);

  const cambiar = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const crear = e => {
    e.preventDefault();
    guardar(data, aceptarTerms, aceptarPolit);
  }

  return (
    <Grid className="form form-sign" size={6}>
      <form noValidate onSubmit={crear}>
        <Grid className="content-form">
          <Grid item container
            sx={{
              alignItems:"center",
              justifyContent:"center"
            }}>
            <Typography variant="h3" component="h3">Crear cuenta</Typography>
          </Grid>
          <TextField
            className="input-sigup"
            error={isEmpty(error.username) ? false : true}
            required
            fullWidth
            id="username"
            label="Nombre de usuario"
            name="username"
            value={data.username}
            onChange={cambiar}
            helperText={!isEmpty(error.username) && error.username}
          />
          <TextField
            className="input-sigup"
            error={isEmpty(error.email) ? false : true}
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={data.email}
            onChange={cambiar}
            helperText={!isEmpty(error.email) && error.email}
          />
          <Grid container spacing={1} mb={1}>
            <Grid item size={{xs: 5, md: 4}}>
              <FormControl sx={{width: "100%"}}>
                <Select
                  autoWidth
                  name="prefijo"
                  className="input-sigup"
                  value={data.prefijo}
                  onChange={cambiar}
                  IconComponent={() => <ArrowDropDownCircleIcon color="primary" />}
                >
                  <MenuItem value="52"><img alt="México" width="20" src="/mexico.png" /> +52</MenuItem>
                  <MenuItem value="1"><img alt="EEUU" width="20" src="/eeuu.png" /> +1</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item size={{xs: 7, md: 8}}>
              <TextField
                error={isEmpty(error.tel) ? false : true}
                variant="outlined"
                required
                fullWidth
                id="tel"
                label="Número celular"
                type='number'
                name="tel"
                value={data.tel}
                onChange={cambiar}
                helperText={!isEmpty(error.tel) && error.tel}
              />
            </Grid>
          </Grid>
          <TextField
            className="input-sigup"
            fullWidth
            variant="outlined"
            error={isEmpty(error.pass) ? false : true}
            label="Contraseña"
            name="pass"
            type={showPassword ? "text" : "password"}
            value={data.pass}
            onChange={cambiar}
            helperText={!isEmpty(error.pass) && error.pass}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="mostrar u ocultar contraseña"
                      onClick={() => setShowPassword((v) => !v)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
          <TextField
            className="input-sigup"
            fullWidth
            variant="outlined"
            error={isEmpty(error.confirmarPass) ? false : true}
            label="Confirmar contraseña"
            name="confirmarPass"
            type={showConfimPassword ? "text" : "password"}
            value={data.confirmarPass}
            onChange={cambiar}
            helperText={!isEmpty(error.confirmarPass) && error.confirmarPass}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="mostrar u ocultar contraseña"
                      onClick={() => setShowConfimPassword((v) => !v)}
                      edge="end"
                    >
                      {showConfimPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
          <FormControl 
            error={isEmpty(error.terminos) && isEmpty(error.politicas) ? false : true}
          >
            <FormGroup sx={{ width: "100%" }}>
              <FormControlLabel
                sx={{ mb: 3 }}
                control={
                  <Checkbox
                    sx={{ color: "#D8DADC", transform: "scale(0.8)", paddingBottom: 0, paddingTop: 0 }}
                    name="terminos"
                    color="primary"
                    value={aceptarTerms}
                    onChange={(e) => setAceptarTerms(e.target.checked)}
                  />
                }
                label={
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <span>Acepto&nbsp;</span>
                    <Link to={'/'}>términos y condiciones</Link>
                  </div>
                }
                required
              />
              <FormControlLabel
                required
                control={
                  <Checkbox
                    sx={{ color: "#D8DADC", transform: "scale(0.8)", paddingBottom: 0, paddingTop: 0 }}
                    name="politica"
                    color="primary"
                    value={aceptarPolit}
                    onChange={(e) => setAceptarPolit(e.target.checked)}
                  />
                }
                label={
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <span>He leído la&nbsp;</span>
                    <Link to={'/'}>política de privacidad</Link>
                  </div>
                }
              />
              <FormHelperText>
                {
                  (!isEmpty(error.terminos) || !isEmpty(error.politicas)) && 
                  error.terminos  + ' ' + error.politicas
                }
              </FormHelperText>
            </FormGroup>
          </FormControl>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={disable}
          sx={{mb: 5, mt: 3}}
        >
          Siguiente
        </Button>
        <Typography align='center' sx={{ mb: 1}}>
          Ingresar <Link href='/'>aquí</Link>
        </Typography>
        <Grid container>
          <Grid size={12}>
            <Divider component="div" role="presentation">
              <Typography variant="body2" color="#000000B2">
                Regístrate con:
              </Typography>
            </Divider>
          </Grid>
          <Grid item container direction="row" mt={2} spacing={3} size={12}>
            <Grid item size={6}>
              <FacebookLogin
                appId={FACEBOOK_APP}
                onSuccess={facebook}
                render={renderProps => (
                  <Button className="btn-facebook" onClick={renderProps.onClick}>
                    <img alt="facebook" width="25" src="/facebook.png"
                      style={{ margin: 10 }}
                    />
                    <Typography variant="h5">
                      Facebook
                    </Typography>
                  </Button>
                )}
              />
            </Grid>
            <Grid item size={6}>
              <Button className="btn-google" onClick={() => google()}>
                <img alt="google" width="25" src="/google.png"
                  style={{ margin: 10 }}
                /> 
                <Typography variant="h5">Google</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}

SignUpForm.propTypes = {
  guardar: PropTypes.func.isRequired,
  google: PropTypes.func.isRequired,
  facebook: PropTypes.func.isRequired,
  error: PropTypes.object,
  disable: PropTypes.bool,
}

export default SignUpForm;